// extracted by mini-css-extract-plugin
export default {"content":"MainContainer_content__rS7jY"};